import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=49574100&"
import script from "./CommonButton.vue?vue&type=script&lang=js&"
export * from "./CommonButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports